import { render, staticRenderFns } from "./TransfusionVolumeSpeedCalculator.vue?vue&type=template&id=161b41e4"
import script from "./TransfusionVolumeSpeedCalculator.vue?vue&type=script&lang=js"
export * from "./TransfusionVolumeSpeedCalculator.vue?vue&type=script&lang=js"
import style0 from "./TransfusionVolumeSpeedCalculator.vue?vue&type=style&index=0&id=161b41e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports